module.exports = __webpack_public_path__ + "static/media/vivi-epi.b4c5e43f.svg";